import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'callCategory'
})
export class CallCategoryPipe implements PipeTransform{
    transform(value: string) {
        switch (value) {
            case "cash":
                return 'Equity Cash';
            case "future" :
            case "options":
                return 'Equity F&O';
            // case "options":
            //     return 'Equity Options';
            case "commodity_future":
                return 'Commodity Future';
            case "commodity_options":
                return 'Commodity Options';
            case "currency_future":
                return 'Currency Future';
            case "currency_options":
                return 'Currency Options';
            case "strategic":
                return 'Strategy';
            case "future,options":
                return 'Equity F&O';
            case "commodity_options,commodity_future":
                return 'Commodity F&O';
            case "currency_options,currency_future":
                return 'Currency F&O';
            default:
                return '';
        }
    }
}

@NgModule({
    declarations: [CallCategoryPipe],
    exports: [CallCategoryPipe]
})
export class CallCategoryPipeModule {}